import { CustomerMetafields, ShopMetafields } from '~/types'
import useHeader from '../useHeader';
import CustomDesktopHeader from './CustomDesktopHeader.client';
import CustomMenuDrawer from './CustomMenuDrawer.client';
import CustomMobileHeader from './CustomMobileHeader.client';

type HeaderProps = {
  storeName: string,
  shop: ShopMetafields,
  desktopHeader?: JSX.Element,
  mobileHeader?: JSX.Element,
  menuDrawer?: JSX.Element,
  customer?: CustomerMetafields
}

export default function CustomHeader({ storeName, shop, customer }: HeaderProps) {

  const {
    isCartOpen,
    closeCart,
    setShowCategory,
    goTo,
    openCart,
    showCategory,
    menuItems,
    shopSettings,
    openMenu,
    isMenuOpen,
    closeMenu
  } = useHeader({ shop });

  return (
    <>
      <CustomDesktopHeader
        isCartOpen={isCartOpen}
        closeCart={closeCart}
        setShowCategory={setShowCategory}
        goTo={goTo}
        openCart={openCart}
        showCategory={showCategory}
        menuItems={menuItems}
        shopSettings={shopSettings}
        currency={shop.moneyFormat}
        customer={customer}
        tagline={shop.tagline}
      />

      <CustomMobileHeader
        openMenu={openMenu}
        openCart={openCart}
        customer={customer}
      />

      <CustomMenuDrawer
        menuItems={menuItems}
        isOpen={isMenuOpen}
        onClose={closeMenu}
        showCategory={showCategory}
        setShowCategory={setShowCategory}
        goTo={goTo}
        storeName={storeName}
        shopSettings={shopSettings}
      />
    </>
  )
}








